angular.module('qkr')
    .directive('loadingSpinner', (appConfig, subscriptionService, usSpinnerService, APP_CONSTANT) => ({
        restrict: 'E',
        template: require('../templates/common/loadingSpinner.html'),
        link: ($scope) => {
            subscriptionService.subscribeAction(APP_CONSTANT.SubscriptionService.REMOVE_SPINNER, () => {
                usSpinnerService.stop('spinner-1');
                $scope.isSpinnerVisible = false;
            });
        }
    })
);



// WEBPACK FOOTER //
// ./src/directives/loadingSpinner.js